import { Directive, ElementRef, HostListener, Optional } from '@angular/core';

import { RenderEvent } from 'render/render-events/render-events.model';
import { RenderEventsService } from 'render/render-events/render-events.service';
import { RenderLinkComponent } from 'render/render-shared/render-link/render-link.component';


@Directive({
  selector: 'a'
})
export class RenderLinksEventsDirective {

  constructor(
    private readonly renderEventsService: RenderEventsService,
    private readonly elementRef: ElementRef<HTMLAnchorElement>,
    @Optional() private readonly renderLink: RenderLinkComponent
  ) {
  }

  @HostListener('click', ['$event'])
  public click(event: Event): void {
    const linkData = {
      event,
      extra: null,
      location: null
    } as RenderEvent;

    if (this.renderLink) {
      linkData.extra = this.renderLink.link;
      if (!this.renderLink.link.src) {
        linkData.extra = {
          ...linkData.extra,
          src: this.elementRef.nativeElement.href
        };
      }
    }
    event.stopPropagation();
    linkData.location = this.renderLink?.piece?.name ?? '';
    this.renderEventsService.events.next(linkData);
  }

}
